<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="标签管理">
      <!-- 超管、开发者才可以新增 -->
      <template v-if="roleId == 1">
        <el-button size="small" type="primary" @click="newlyAdded"
          >新增</el-button
        >
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">

         <template v-slot:operation="row">
            <div style="display: flex; align-items: center">
                <template v-if="roleId == 1">
                <div class="button button_modify" @click="editButton(row.row)">
                    <i class="iconfont icon-bianji"></i> 编辑
                </div>
                <div class="button button_revoke" @click="deleteRows(row.row)">
                    <i class="iconfont icon-shanchu"></i> 删除
                </div>
                </template>
            </div>
         </template>

    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import {
  getItemlabelList,
  itemLabelDel,
} from "@/api/basicConfiguration";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
  is_showAll: 1,
};
export default {
  name: "labelManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      roleId: 0,
      compId: 0,
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "标签",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "标签名称",
            prop: "label_name",
            width: 260,
          },
          {
            label: "标签描述",
            prop: "label_desc",
            width: 260,
          },
          {
            label: "排序",
            prop: "sort_by",
            width: 150,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 门店管理中：商户只能编辑基础信息
    this.roleId = this.$store.getters.userRole;
    // if (this.roleId != 1) {
    //   this.basicListconfig.search.shift();
    // }
    this.compId = this.$store.getters.userInfo.compId;

    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemLabelDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;

      getItemlabelList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    obtainDataSource() {

    },

  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/labelManagement/index.vue